declare global {
	interface Window {
		CLIENT_ENV: Record<string, EnvVarValue>;
		FS?: { [key: string]: any };
	}
}

type EnvVarValue = string | boolean | number | undefined | Record<string, unknown> | EnvVarValue[];

const getConfig = (webpackEnv: { [key: string]: any } = {}) => {
	const envVars: { [key: string]: any } = Object.keys(webpackEnv).reduce((acc, key) => {
		let value = webpackEnv[key];

		// convert boolean strings to boolean types
		value = value === 'true' ? true : value;
		value = value === 'false' ? false : value;

		// convert JSON values
		if (typeof value === 'string' && value.startsWith('{') && value.endsWith('}')) {
			try {
				value = JSON.parse(value);
			} catch (e) {
				// console.log(e);
			}
		}

		return {
			...acc,
			[key.replace(/^NX_PUBLIC_/, '')]: value,
		};
	}, {});

	return {
		...envVars,
		...((typeof window !== 'undefined' && window.CLIENT_ENV) || {}),
	};
};

export { getConfig };
